import * as React from 'react';

import { Dispatch } from 'redux';
import { connect } from 'react-redux';
import { Translate } from 'react-localize-redux';

import AppState from '@webapp/store/state';
import { UpdateTracPageField } from '@webapp/store/tracpage/action-creators';

import TracPage from '@services/tracpage/types/trac-page';
import { TracThemeType } from '@services/tracpage/types/trac-theme-type';

import Box from '@components/layout/box';
import BoxHeader from '@components/layout/box-header';
import CustomDomain from '@components/artist/custom-domain';
import MotionOpacity from '@components/motion/motion-opacity';

import DarkLightCtrl from '@webapp/controllers/dark-light-dropdown';

import ArtistHomePage from '../home';

interface ArtistGeneralWebPageProps {
  theme: TracThemeType;
  updateTheme: (value: TracThemeType) => UpdateTracPageField<TracPage, 'theme'>;
}

const mapStateToProps = (props: AppState) => ({
  theme: props.tracpage.artistPage.theme,
});

const mapDispatchToProps = (dispatch: Dispatch) => ({
  updateTheme: (value: TracThemeType) =>
    dispatch(
      new UpdateTracPageField<TracPage, 'theme'>('tracpage', 'theme', value)
    ),
});

export const ArtistGeneralWebPage: React.FC<ArtistGeneralWebPageProps> = ({
  theme,
  updateTheme,
}) => {
  return (
    <MotionOpacity>
      <Box className="mb-30">
        <BoxHeader
          title={<Translate id="ARTIST_SITE.APPEARANCE.TITLE" />}
          text={<Translate id="ARTIST_SITE.APPEARANCE.TEXT" />}
        />
        <DarkLightCtrl
          value={theme}
          className={'mb-20'}
          onChange={(value) => updateTheme(value)}
        />
        <CustomDomain />
        <ArtistHomePage />
      </Box>
    </MotionOpacity>
  );
};
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ArtistGeneralWebPage);
